/** Shared dashed "add row" button styling for Create Event form sections */
export const eventsSectionAddButtonSx = {
	mb: 2,
	border: '1px dashed #1976D2',
	color: '#1976D2',
	borderRadius: '6px',
	py: 1,
	px: 2,
	minHeight: 40,
	textTransform: 'none',
	fontSize: 14,
	fontWeight: 500,
	lineHeight: 1,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	'&:hover': { background: 'rgba(25,118,210,0.04)' },
	'&.Mui-disabled': { borderColor: 'rgba(0,0,0,0.26)', color: 'rgba(0,0,0,0.26)' },
};

/** Inner label row — use instead of startIcon for reliable icon/text alignment */
export const eventsSectionAddButtonLabelSx = {
	display: 'inline-flex',
	alignItems: 'center',
	justifyContent: 'center',
	gap: 0.75,
	lineHeight: 1,
};

export const eventsSectionAddButtonIconSx = {
	fontSize: 18,
	display: 'block',
};
